/**
 * Cookie 工具类
 */
const CookieUtil = {
    /**
     * 设置 Cookie
     * @param {string} name - Cookie 名称
     * @param {string} value - Cookie 值
     * @param {Object} options - 配置选项
     * @param {number|Date} options.expires - 过期时间（天数或Date对象）
     * @param {string} options.path - 路径，默认为 '/'
     * @param {string} options.domain - 域名
     * @param {boolean} options.secure - 是否仅HTTPS
     * @param {'Strict'|'Lax'|'None'} options.sameSite - 同站策略
     */
    set(name, value, options = {}) {
        let cookieStr = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;
        
        // 处理过期时间
        if (options.expires) {
            let expiresDate;
            if (typeof options.expires === 'number') {
                expiresDate = new Date();
                expiresDate.setDate(expiresDate.getDate() + options.expires);
            } else if (options.expires instanceof Date) {
                expiresDate = options.expires;
            }
            cookieStr += `; expires=${expiresDate.toUTCString()}`;
        }
        
        // 路径
        cookieStr += `; path=${options.path || '/'}`;
        
        // 域名
        if (options.domain) {
            cookieStr += `; domain=${options.domain}`;
        }
        
        // 安全标志
        if (options.secure) {
            cookieStr += '; Secure';
        }
        
        // 同站策略
        if (options.sameSite) {
            cookieStr += `; SameSite=${options.sameSite}`;
        }
        
        document.cookie = cookieStr;
    },
    
    /**
     * 设置当天23:59:59过期的Cookie
     * @param {string} name - Cookie 名称
     * @param {string} value - Cookie 值
     * @param {Object} options - 额外配置（不包含expires）
     */
    setDaily(name, value, options = {}) {
        const expires = new Date();
        expires.setHours(23, 59, 59, 0);
        
        this.set(name, value, {
            ...options,
            expires: expires
        });
    },
    
    /**
     * 获取 Cookie 值
     * @param {string} name - Cookie 名称
     * @returns {string|null} Cookie 值，不存在返回 null
     */
    get(name) {
        const nameEncoded = encodeURIComponent(name);
        const cookies = document.cookie.split('; ');
        
        for (const cookie of cookies) {
            const [cookieName, cookieValue] = cookie.split('=');
            if (cookieName === nameEncoded) {
                return decodeURIComponent(cookieValue);
            }
        }
        
        return null;
    },
    
    /**
     * 获取所有 Cookie
     * @returns {Object} 所有 Cookie 键值对
     */
    getAll() {
        const cookies = {};
        
        if (document.cookie) {
            document.cookie.split('; ').forEach(cookie => {
                const [name, value] = cookie.split('=');
                cookies[decodeURIComponent(name)] = decodeURIComponent(value);
            });
        }
        
        return cookies;
    },
    
    /**
     * 检查 Cookie 是否存在
     * @param {string} name - Cookie 名称
     * @returns {boolean} 是否存在
     */
    has(name) {
        return this.get(name) !== null;
    },
    
    /**
     * 删除 Cookie
     * @param {string} name - Cookie 名称
     * @param {Object} options - 删除时的配置（需与设置时一致）
     */
    remove(name, options = {}) {
        this.set(name, '', {
            ...options,
            expires: new Date(0) // 设置为过去时间
        });
    },
    
    /**
     * 设置会话 Cookie（浏览器关闭时过期）
     * @param {string} name - Cookie 名称
     * @param {string} value - Cookie 值
     * @param {Object} options - 额外配置
     */
    setSession(name, value, options = {}) {
        this.set(name, value, options); // 不设置expires即为会话cookie
    }
};

export default CookieUtil;